import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';

@Component({
  selector: 'online-app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss']
})
export class ApplicationComponent implements OnInit {

  constructor(private store: Store<any>) { }

  ngOnInit() {

    // console.log(`In ngOnInit of Application Component`);

    // console.log(localStorage.getItem('PRE_REGISTER_INFO'));

    // this.store.pipe(select('preRegistration'))
    //           .subscribe( preRegistrationInfo => {
    //             if (preRegistrationInfo) {
    //               console.log('in ngoninit applications');
    //               console.log(preRegistrationInfo);
    //             }
    //           });
  }

}
